import React from "react";
import RichTextPage from "../RichTextPage";

/** KVKK / gizlilik metni — Türkçe `Kvkk`, çeviriler `Kvkk_Lang`. */
export default function KvkkText() {
  return (
    <RichTextPage
      pageTitle="KVKK Metni"
      description="KVKK ve Gizlilik sayfasının metni bu ekrandan yönetilir."
      where="Girilen metin sitedeki KVKK sayfasında ve mobil uygulamadaki KVKK ekranında gösterilir. Boş bırakılırsa ikisinde de kısa bir bilgilendirme cümlesi görünür."
      links={[{ label: 'KVKK sayfası', path: '/kvkk' }]}
      trTable="Kvkk"
      trField="Kvkk_Html"
      langTable="Kvkk_Lang"
      langField="Kvkk_Html"
    />
  );
}
